// extracted by mini-css-extract-plugin
module.exports = {"ToDoItem":"ToDoItem_ToDoItem__1_TFh","active":"ToDoItem_active__2-Ep5","Completed":"ToDoItem_Completed__3XXrA"};